export default "__VITE_ASSET__i_zoo1_a__"